import { /* baseClient, */ authClient, API } from '../../utils/index';

export function getParticipantsByRegatta(id) {
	return authClient().get(`${API}/participant/by-regatta/${id}`);
}

// Create participant
export const postParticipant = async (participant) => {
	return authClient().post(`${API}/participant`, participant);
};

// Delete participant
export const deleteParticipant = (id) => {
  return authClient().delete(`${API}/participant/${id}`)
}

// Update participant
export const updateParticipant = (id, payload) => {
  return authClient().put(`${API}/participant/${id}`, payload)
}
